import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/site";
import { Reveal } from "@/lib/motion";

export default function Services() {
    return (
        <section id="services" className="px-5 md:px-10 py-24 md:py-32 border-t border-line">
            <div className="grid grid-cols-12 gap-y-8 md:gap-12">
                <div className="col-span-12 md:col-span-5">
                    <div className="md:sticky md:top-24">
                        <Reveal>
                            <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-inkdim">Services</p>
                            <h2 className="mt-6 font-display font-extrabold uppercase tracking-[-0.02em] leading-[0.95] text-4xl md:text-6xl">
                                What I <em className="font-serif italic font-medium normal-case">do.</em>
                            </h2>
                            <p className="mt-6 text-inkdim max-w-sm text-base md:text-lg leading-relaxed">
                                One pair of eyes on the image, from the first idea to the final frame.
                            </p>
                        </Reveal>
                    </div>
                </div>

                <div className="col-span-12 md:col-span-7">
                    {SERVICES.map((s, i) => (
                        <Reveal key={s} delay={Math.min(i * 0.03, 0.2)}>
                            <div
                                data-testid={`service-row-${i}`}
                                className="group flex items-center justify-between gap-4 border-t border-line py-5 md:py-6 px-2 hover:px-4 hover:bg-surface transition-all duration-300 cursor-default"
                            >
                                <div className="flex items-baseline gap-5">
                                    <span className="text-[10px] font-bold tracking-[0.2em] text-inkdim">
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                    <span className="font-display font-extrabold uppercase tracking-tight text-lg md:text-2xl">
                                        {s}
                                    </span>
                                </div>
                                <ArrowUpRight
                                    size={20}
                                    className="opacity-0 -translate-x-1 translate-y-1 group-hover:opacity-100 group-hover:translate-x-0 group-hover:translate-y-0 transition-all duration-300"
                                />
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
